<pw-view-title
>{{ (pos$ | async)?.NAME }}
  {{ 'orders.blanks.blanks' | translate }}
</pw-view-title>

<div>

  <h3>Platinenmaße</h3>

  <table mat-table [dataSource]="dataSourceMeasures" class="mat-elevation-z8 measures-table">
    <tr mat-header-row *matHeaderRowDef="displayedColumnsMeasures"></tr>
    <tr [ngClass]="removeBorders(i) ? 'measures-row' : ''" mat-row
        *matRowDef="let row; let i = index; columns: displayedColumnsMeasures"></tr>


    <ng-container matColumnDef="BLANK">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.blank' | translate }}</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <ng-container *ngIf="removeButtonsAndText(i)">
          {{ element.blankMaterialText }}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="STATUS">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.measureType' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.measure.measureTypeText }}
      </td>
    </ng-container>

    <ng-container matColumnDef="LENGTH">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.length' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.measure.measureLength }}
      </td>
    </ng-container>

    <ng-container matColumnDef="WIDTH">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.width' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.measure.measureWidth }}
      </td>
    </ng-container>

    <ng-container matColumnDef="QUANTITY">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.quantity' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.measure.measureQuantity }}
      </td>
    </ng-container>

    <ng-container matColumnDef="ACTIONS">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.actions' | translate }}</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <ng-container *ngIf="removeButtonsAndText(i)">
          <button [disabled]="!element.blankMeasureRequestPermitted" mat-icon-button
                  matTooltip="{{'orders.positions.bm.actionsMeasures.update' | translate}}"
                  (click)="updateOrRequestMeasure(element,'PLA_MA_AN')">
            <mat-icon>assignment_add</mat-icon>
          </button>
          <button [disabled]="!element.blankMeasureChangePermitted" mat-icon-button
                  matTooltip="{{'orders.positions.bm.actionsMeasures.approve' | translate}}"
                  (click)="updateOrRequestMeasure(element,'PLA_MA_AB')">
            <mat-icon>assignment_turned_in</mat-icon>
          </button>
        </ng-container>
      </td>
    </ng-container>

  </table>


  <h3>{{ 'orders.positions.bm.blanks' | translate }}</h3>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <ng-container matColumnDef="BLANK">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.blank' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.blankMaterialText }}
      </td>
    </ng-container>

    <ng-container matColumnDef="BLANK_MEASURE_TYPE_TEXT">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.measureType' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.blankMeasureTypeText; else notAvailable">
          {{ element.blankMeasureTypeText }}
        </ng-container>

      </td>
    </ng-container>

    <ng-container matColumnDef="BLANK_DEMAND">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.blankDemand' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.blankDemandName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="BLANK_DEMAND_COUNT">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.quantityBlanks' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.blankDemandCount }}
      </td>
    </ng-container>

    <ng-container matColumnDef="BLANK_LENGTH">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.length' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.blankMeasureTypeText; else notAvailable">
          {{ element.blankLength | number }} mm
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="BLANK_WIDTH">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.width' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.blankMeasureTypeText; else notAvailable">
          {{ element.blankWidth | number }} mm
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="STATUS">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.status' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="element.blankMeasureTypeText; else notAvailable" class="{{ getDemandStatusClass(element) }}">
          {{ element.blankDemandStatusText }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="DELIVERY_DEADLINE">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.deliveryDate' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.blankDemandDeliveryDateTarget | date }}
      </td>
    </ng-container>

    <ng-container matColumnDef="DELIVERY_DATE">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.deliveryDateActual' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.blankDemandDeliveryDateActual | date }}
      </td>
    </ng-container>


    <ng-container matColumnDef="ACTIONS">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.actions' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <button [disabled]="!element.blankStatusCreationPermitted" mat-icon-button
                matTooltip="{{'orders.positions.bm.createProjectStatus' | translate}}" (click)="createStatus(element)">
          <mat-icon>note_add</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsBlanks"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsBlanks"></tr>
  </table>

  <h3>{{ 'orders.positions.bm.blankStatusReports' | translate }}</h3>

  <table mat-table [dataSource]="status$ | async" class="mat-elevation-z8">
    <ng-container matColumnDef="DATE_CREATION">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.date' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.creationDate | date }}
      </td>
    </ng-container>

    <ng-container matColumnDef="STATUS_NAME">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.status' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <span class="{{ getReportStatusClass(element) }}">
          {{ element.statusName }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="ADDITIONAL_DEMAND">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.additionalDemand' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.additionalDemand | number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="DAMAGE_PRE_MANUFACTURING">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.damagePreManufacturing' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.damagePreManufacturing | number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="DAMAGE_MANUFACTURING">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.damageManufacturing' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.damageManufacturing | number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="INFO">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.supplierHint' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.supplierHint }}
      </td>
    </ng-container>

    <ng-container matColumnDef="BLANK_DEMAND_NAME">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.blankDemand' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.blankDemandsText }}
      </td>
    </ng-container>

    <ng-container matColumnDef="REMARK">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.remarkBMW' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.remark }}
      </td>
    </ng-container>

    <ng-container matColumnDef="ACTIONS">
      <th mat-header-cell *matHeaderCellDef>{{ 'orders.positions.bm.actions' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button (click)="deleteStatus(element)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsStatus"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsStatus"></tr>
  </table>
</div>
<ng-template #notAvailable>n.a.</ng-template>
